module.exports = __webpack_public_path__ + "img/eye-open.8d87c045.svg";